import { render, staticRenderFns } from "./list.page.vue?vue&type=template&id=458ea1c8&scoped=true"
import script from "./list.page.vue?vue&type=script&lang=ts"
export * from "./list.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458ea1c8",
  null
  
)

export default component.exports